export const fieldType = [
  { value: "", text: "업종" },
  { value: "I01", text: "농업" },
  { value: "I02", text: "임업" },
  { value: "I03", text: "어업" },
  { value: "I05", text: "석탄, 원유 및 천연가스 광업" },
  { value: "I06", text: "금속 광업" },
  { value: "I07", text: "비금속광물 광업 연료용 제외" },
  { value: "I08", text: "광업 지원 서비스업" },
  { value: "I10", text: "식료품 제조업" },
  { value: "I11", text: "음료 제조업" },
  { value: "I12", text: "담배 제조업" },
  { value: "I13", text: "섬유제품 제조업 의복제외" },
  { value: "I14", text: "의복, 의복 액세서리 및 모피제품 제조업" },
  { value: "I15", text: "가죽, 가방 및 신발 제조업" },
  { value: "I16", text: "목재 및 나무제품 제조업 가구 제외" },
  { value: "I17", text: "펄프, 종이 및 종이제품 제조업" },
  { value: "I18", text: "인쇄 및 기록매체 복제업" },
  { value: "I19", text: "코크스, 연탄 및 석유정제품 제조업" },
  { value: "I20", text: "화학물질 및 화학제품 제조업 의약품 제외" },
  { value: "I21", text: "의료용 물질 및 의약품 제조업" },
  { value: "I22", text: "고무 및 플라스틱제품 제조업" },
  { value: "I23", text: "비금속 광물제품 제조업" },
  { value: "I24", text: "1차 금속 제조업" },
  { value: "I25", text: "금속가공제품 제조업 기계 및 가구 제외" },
  { value: "I26", text: "전자부품, 컴퓨터, 영상, 음향 및 통신장비 제조업" },
  { value: "I27", text: "의료, 정밀, 광학기기 및 시계 제조업" },
  { value: "I28", text: "전기장비 제조업" },
  { value: "I29", text: "기타 기계 및 장비 제조업" },
  { value: "I30", text: "자동차 및 트레일러 제조업" },
  { value: "I31", text: "기타 운송장비 제조업" },
  { value: "I32", text: "가구 제조업" },
  { value: "I33", text: "기타 제품 제조업" },
  { value: "I34", text: "산업용 기계 및 장비 수리업" },
  { value: "I35", text: "전기, 가스, 증기 및 공기조절 공급업" },
  { value: "I36", text: "수도업" },
  { value: "I37", text: "하수, 폐수 및 분뇨 처리업" },
  { value: "I38", text: "폐기물 수집, 운반, 처리 및 원료 재생업" },
  { value: "I39", text: "환경 정화 및 복원업" },
  { value: "I41", text: "종합 건설업" },
  { value: "I42", text: "전문직별 공사업" },
  { value: "I45", text: "자동차 및 부품 판매업" },
  { value: "I46", text: "도매 및 상품 중개업" },
  { value: "I47", text: "소매업 자동차 제외" },
  { value: "I49", text: "육상운송 및 파이프라인 운송업" },
  { value: "I50", text: "수상 운송업" },
  { value: "I51", text: "항공 운송업" },
  { value: "I51", text: "창고 및 운송관련 서비스업" },
  { value: "I55", text: "숙박업" },
  { value: "I56", text: "음식점 및 주점업" },
  { value: "I58", text: "출판업" },
  { value: "I59", text: "영상ㆍ오디오 기록물 제작 및 배급업" },
  { value: "I60", text: "방송업" },
  { value: "I61", text: "우편 및 통신업" },
  { value: "I62", text: "컴퓨터 프로그래밍, 시스템 통합 및 관리업" },
  { value: "I63", text: "정보서비스업" },
  { value: "I64", text: "금융업" },
  { value: "I65", text: "보험 및 연금업" },
  { value: "I66", text: "금융 및 보험 관련 서비스업" },
  { value: "I68", text: "부동산업" },
  { value: "I70", text: "연구개발업" },
  { value: "I71", text: "전문 서비스업" },
  { value: "I72", text: "건축기술, 엔지니어링 및 기타 과학기술 서비스업" },
  { value: "I73", text: "기타 전문, 과학 및 기술 서비스업" },
  { value: "I74", text: "사업시설 관리 및 조경 서비스업" },
  { value: "I75", text: "사업지원 서비스업" },
  { value: "I76", text: "임대업 부동산 제외" },
  { value: "I84", text: "공공행정, 국방 및 사회보장 행정" },
  { value: "I85", text: "교육 서비스업" },
  { value: "I86", text: "보건업" },
  { value: "I87", text: "사회복지 서비스업" },
  { value: "I90", text: "창작, 예술 및 여가관련 서비스업" },
  { value: "I91", text: "스포츠 및 오락관련 서비스업" },
  { value: "I94", text: "협회 및 단체" },
  { value: "I95", text: "개인 및 소비용품 수리업" },
  { value: "I96", text: "기타 개인 서비스업" },
  { value: "I97", text: "가구 내 고용활동" },
  {
    value: "I98",
    text: "달리 분류되지 않은 자가소비를 위한 가구의 재화 및 서비스 생산활동",
  },
  { value: "I99", text: "국제 및 외국기관" },
  { value: "I100", text: "정보통신업" },
  { value: "I101", text: "도매 및 소매업" },
];

export const companyType = [
  { value: "", text: "기업형태" },
  { value: "ET01", text: "개인기업" },
  { value: "ET02", text: "합명회사" },
  { value: "ET03", text: "합자회사" },
  { value: "ET04", text: "유한회사" },
  { value: "ET05", text: "협동조합" },
  { value: "ET06", text: "주식회사" },
  { value: "ET07", text: "공기업" },
  { value: "ET08", text: "영세기업(스타트업)" },
  { value: "ET09", text: "중소기업" },
  { value: "ET10", text: "중견기업" },
  { value: "ET11", text: "대기업" },
  { value: "ET12", text: "기타" },
];

export const companyTypeList = [
  { value: null, text: "기업형태" },
  { value: "ET01", text: "개인기업" },
  { value: "ET02", text: "합명회사" },
  { value: "ET03", text: "합자회사" },
  { value: "ET04", text: "유한회사" },
  { value: "ET05", text: "협동조합" },
  { value: "ET06", text: "주식회사" },
  { value: "ET07", text: "공기업" },
  { value: "ET08", text: "영세기업(스타트업)" },
  { value: "ET09", text: "중소기업" },
  { value: "ET10", text: "중견기업" },
  { value: "ET11", text: "대기업" },
  { value: "ET12", text: "기타" },
];
